
import $ from 'jQuery';


export default function() {

  $(function() {
    initialize_animations();
  });


  function initialize_animations() {
    const $animateIn = $('.node--full .content__paragraphs [data-animate]');
    const supportsIntersectionObserver = !!window.IntersectionObserver;


    if (supportsIntersectionObserver && $animateIn.length) {
      const targetElements = $animateIn.get();

      let firstObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {

          if (entry.isIntersecting) {
            if (entry.intersectionRatio >= 0) {
              $(entry.target).addClass('--animate-in');
            }
          }
        });
      }, {
        root: null,
        rootMargin: "0px",
        threshold: [0]
      });

      targetElements.forEach(observedEl => {
        firstObserver.observe(observedEl);
      });
    }
  }
}
